<template>
  <b-container
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-container fluid>

      <b-row>
        <b-col
          cols="12"
          order="1"
          class="px-1"
        >
          <b-form-group
            label="Search"
            label-for="filter_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_search"
              v-model="tableFiscalYear.filter.search"
              type="text"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          order="3"
          class="px-1 mb-2"
        >
          <b-button
            size="sm"
            type="button"
            variant="success"
            @click="onCreateFiscalYear"
          >
            Add Fiscal Year
          </b-button>
        </b-col>

      </b-row>

      <b-row
        class="mt-1"
      >
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableFiscalYear"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableFiscalYear.perPage"
            :current-page="tableFiscalYear.currentPage"
            :items="tableFiscalYearProvider"
            :fields="tableFiscalYear.fields"
            :sort-by.sync="tableFiscalYear.sortBy"
            :sort-desc.sync="tableFiscalYear.sortDesc"
            :sort-direction="tableFiscalYear.sortDirection"
            :filter="tableFiscalYear.filter"
            :filter-included-fields="tableFiscalYear.filterOn"
            :busy="tableFiscalYear.busy"
          >
            <template #cell(index)="row">
              {{ tableFiscalYear.currentPage * tableFiscalYear.perPage - tableFiscalYear.perPage + (row.index + 1) }}
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell(is_current)="row">
              {{ row.item.is_current === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell()="row">
              <div class="text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  size="sm"
                  variant="success"
                  @click="onEditFiscalYear(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>

        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableFiscalYear.perPage"
            :options="tableFiscalYear.pageOptions"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end"
        >
          <b-pagination
            v-model="tableFiscalYear.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableFiscalYear.totalRows"
            :per-page="tableFiscalYear.perPage"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="modal-fiscal-year"
      scrollable
      no-close-on-esc
      no-enforce-focus
      hide-header-close
      no-close-on-backdrop
      :title="ModalFiscalYearTitle"
    >
      <ValidationObserver
        ref="formFiscalYear"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <b-row>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="fiscal name"
                vid="fiscal_name"
                rules="required|max:50"
              >
                <b-form-group
                  label="Fiscal Name"
                  label-for="fiscal_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="fiscal_name"
                    v-model="fiscalYear.fiscal_name"
                    type="text"
                    autocomplete="off"
                    placeholder="enter fiscal name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="date from"
                vid="date_from"
                rules="required"
              >
                <b-form-group
                  label="Date From"
                  label-for="date_from"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="date_from"
                    v-model="fiscalYear.date_from"
                    type="date"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="date to"
                vid="date_to"
                rules="required"
              >
                <b-form-group
                  label="Date To"
                  label-for="date_to"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="date_to"
                    v-model="fiscalYear.date_to"
                    type="date"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="status"
                vid="status"
                rules="required"
              >
                <b-form-group
                  label="Status"
                  label-for="status"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-form-select
                    id="status"
                    v-model="fiscalYear.status"
                    :options="lists.fiscalYearStatuses"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  >
                    <template #first>
                      <b-form-select-option
                        :value="null"
                        disabled
                      >
                        -- select status here --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <b-col
              cols="12"
            >
              <b-form-group>
                <b-form-checkbox
                  id="is_current"
                  v-model="fiscalYear.is_current"
                  switch
                  value="1"
                  name="is_current"
                  unchecked-value="0"
                  :disabled="(state.busy || String(fiscalYear.status) === 'Closed')"
                >
                  Is Current Fiscal Year?
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col
              v-if="state.editing"
              cols="12"
            >
              <b-form-group>
                <b-form-checkbox
                  id="is_active"
                  v-model="fiscalYear.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </b-form-checkbox>
              </b-form-group>
            </b-col>

          </b-row>
        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="onValidateFiscalYear"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="outline-dark"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import QUERY from 'lodash'
import { core } from '@/config/pluginInit'

import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

import { SBOFiscalYear, SSharedList } from '@/services'

export default {
  name: 'BoMaintenancesFiscalYears',

  middleware: ['auth', 'bo'],

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'Fiscal Years'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      fetching: {
        fiscalYearStatuses: false
      },
      lists: {
        fiscalYearStatuses: []
      },
      fiscalYear: {
        id: null,
        fiscal_name: null,
        date_from: null,
        date_to: null,
        status: null,
        is_current: 0,
        active: 1
      },
      tableFiscalYear: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 9, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'fiscal_name' },
          { mobile: 3, key: 'date_from', formatter: this.dateShortFormatter },
          { mobile: 4, key: 'date_to', formatter: this.dateShortFormatter },
          { mobile: 5, key: 'status' },
          { mobile: 6, key: 'is_current', label: 'Current Year', class: 'text-center' },
          { mobile: 7, key: 'active', class: 'text-center' },
          { mobile: 8, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalFiscalYearTitle () {
      return this.state.editing ? 'Edit Fiscal Year' : 'Add Fiscal Year'
    }
  },

  watch: {
    'fiscalYear.status' (status) {
      if (status === 'Closed') {
        this.fiscalYear.is_current = 0
      }
    }
  },

  mounted () {
    core.index()
    this.getFiscalYearStatuses()
  },

  methods: {

    async tableFiscalYearProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableFiscalYear.busy = true
      return await SBOFiscalYear.get(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search
        })
      ).then(({ data }) => {
        this.tableFiscalYear.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableFiscalYear.busy = false
      })
    },

    async getFiscalYearStatuses () {
      this.state.busy = this.fetching.fiscalYearStatuses = true
      return new Promise(resolve => {
        SSharedList.getFiscalYearStatuses().then(
          ({ data }) => {
            this.lists.fiscalYearStatuses = data
            this.state.busy = this.fetching.fiscalYearStatuses = false
            resolve(data)
          }
        )
      })
    },

    onCreateFiscalYear () {
      this.state.editing = false
      this.fiscalYear.id = null
      this.fiscalYear.fiscal_name = null
      this.fiscalYear.date_from = null
      this.fiscalYear.date_to = null
      this.fiscalYear.status = null
      this.fiscalYear.is_current = 0
      this.fiscalYear.active = 1
      this.$bvModal.show('modal-fiscal-year')
    },

    onEditFiscalYear (fiscalYear) {
      this.state.editing = true
      this.fiscalYear.id = fiscalYear.id
      this.fiscalYear.fiscal_name = fiscalYear.fiscal_name
      this.fiscalYear.date_from = fiscalYear.date_from
      this.fiscalYear.date_to = fiscalYear.date_to
      this.fiscalYear.status = fiscalYear.status
      this.fiscalYear.is_current = fiscalYear.is_current
      this.fiscalYear.active = fiscalYear.active
      this.$bvModal.show('modal-fiscal-year')
    },

    async onValidateFiscalYear (event) {
      event.preventDefault()
      await this.$refs.formFiscalYear.validate().then(
        async allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.swalConfirm({
              html: () => {
                if (this.state.editing) {
                  return '<h6>Save your Changes on this Fiscal Year?</h6>'
                }
                return '<h6>Create this Fiscal Year?</h6>'
              },
              preConfirm: () => {
                this.state.busy = true
                if (this.state.editing) {
                  return this.onPutFiscalYear()
                }
                return this.onPostFiscalYear()
              }
            })
          } else {
            this.swalInvalid()
          }
        }
      )
    },

    async onPostFiscalYear () {
      return new Promise(resolve => {
        SBOFiscalYear.post(this.fiscalYear).then(
          ({ data }) => {
            this.$refs.tableFiscalYear.refresh()
            this.swalSuccess(data.message).then(() => {
              this.$bvModal.hide('modal-fiscal-year')
            })
            resolve(data)
          }
        ).catch(
          ({ message }) => {
            this.$refs.formFiscalYear.setErrors(message)
            resolve(message)
          }
        ).finally(() => {
          this.state.busy = false
        })
      })
    },

    async onPutFiscalYear () {
      return new Promise(resolve => {
        SBOFiscalYear.put(this.fiscalYear).then(
          ({ data }) => {
            if (Number(this.fiscalYear.is_current) === 1) {
              this.$refs.tableFiscalYear.localItems.forEach(
                item => {
                  if (Number(item.id) !== Number(data.fiscal_year.id)) {
                    item.is_current = 0
                  }
                }
              )
            }
            const tableFiscalYearRow = QUERY.find(this.$refs.tableFiscalYear.localItems, { id: data.fiscal_year.id })
            if (tableFiscalYearRow) {
              tableFiscalYearRow.fiscal_name = data.fiscal_year.fiscal_name
              tableFiscalYearRow.date_from = data.fiscal_year.date_from
              tableFiscalYearRow.date_to = data.fiscal_year.date_to
              tableFiscalYearRow.status = data.fiscal_year.status
              tableFiscalYearRow.is_current = data.fiscal_year.is_current
              tableFiscalYearRow.active = data.fiscal_year.active
              tableFiscalYearRow.updated_at = data.fiscal_year.updated_at
            }
            this.swalSuccess(data.message).then(() => {
              this.$bvModal.hide('modal-fiscal-year')
            })
            resolve(data)
          }
        ).catch(
          ({ message }) => {
            this.$refs.formFiscalYear.setErrors(message)
            resolve(message)
          }
        ).finally(() => {
          this.state.busy = false
        })
      })
    }
  }
}
</script>
